// Up to 2 decimals, trailing zeros trimmed (150 min -> "2.5", 120 min -> "2").
// 1 decimal isn't enough: a quarter hour (15 min = 0.25h) would round to "0.3".
export function formatMinutesAsHours(minutes: number, decimalMark: '.' | ',' = '.'): string {
  const hours = Math.round((minutes / 60) * 100) / 100;
  const formatted = hours.toFixed(2).replace(/\.?0+$/, '');
  return decimalMark === ',' ? formatted.replace('.', ',') : formatted;
}
